<div class="main-container">
    <div class="wa-cluster wa-gap-l">
  <div class="mobile-only"> <p style="color: red; font-weight: bold;"> Note: This page is not designed to be used on smartphones. Please open it on a larger
  device instead.</p></div>

          <wa-button class="wa-brand" appearance="filled"
                  type="submit"
                  (click)="shibboleth_login()">
            TUM Login
          </wa-button>
      <wa-button class="wa-neutral" appearance="filled"
                  (click)="guest_login()">
            Guest Login
          </wa-button>
      </div>
</div>

